const menu = {
  infoAce: [
    {
      path: "/",
      tag: "Inicio",
      name: "home"
    },
    {
      tag: "Red acelerométrica nacional",
      children: [
        {
          tag: "Información Acelerométrica",
          path: `/informacion-acelerometrica`,
          name: "Información Acelerométrica"
        },
        {
          tag: "Red acelerométrica Nacional",
          path: `/red-acelerometrica`,
          name: "Red acelerométrica Nacional"
        },
        {
          tag: "Reportes y registros acelerométricos",
          path: `/reportes-registros-acelerometricos`,
          name: "¿Cuáles son los objetivos?"
        },
        // {
        //   tag: "Reportes acelerométricos",
        //   path: `/reportes-acelerometricos`,
        //   name: "Normatividad IDE IGP"
        // },
        {
            path: "/sismos-historicos",
            tag: "Sismos Históricos",
            name: "home"
         }
      ]
    },
    {
      tag: "Edificaciones",
      children: [
        {
          tag: "Norma E.030",
          path: `/norma-e.030`,
          name: "Norma E.030"
        },
        
        {
          tag: "Acelerómetros Especificaciones Técnicas",
          path: '/especificaciones-tecnicas',
          name: "Acelerómetros Especificaciones Técnicas"
        },
        {
          tag: "Registros",
          path: `/edificaciones-instrumentadas`,
          name: "Edificaciones Instrumentadas"
        },
      ]
      },
    /*  {
       tag: "Norma E.030",
       children: [
         {
           tag: "Norma E.030",
           path: `/norma-e.030`,
           name: "Qué es el IDE IGP?"
         },
         {
           tag: "Acelerómetros Especificaciones Técnicas",
           path: `/norma-e.030/especificaciones-tecnicas`,
           name: "Acelerómetros Especificaciones Técnicas"
         },
         {
           tag: "Información acelerométrica",
           path: `/norma-e.030/informacion-acelerometrica-norma-e0.30`,
           name: "Información acelerométrica"
         },
         {
           tag: "Edificios Instrumentados",
           path: `/norma-e.030/edificios-instrumentados`,
           name: "Edificios"
         },
        ]
      }, */
        // {
        //   tag: "Reportes y registros acelerométricos",
        //   path: `/norma-e.030/reportes-registros-norma-e.030`,
        //   name: "Normatividad IDE IGP"
        // },
    //     {
    //       tag: "Reportes y registros acelerométricos",
    //       path: `/norma-e.030/reportes-norma`,
    //       name: "Normatividad IDE IGP"
    //     }
    //   ]
    // },
    // {
    //   tag: "Productos",
    //   children: [
    //     {
    //       tag: "Reportes acelerométricos",
    //       path: `/reportes-acelerometricos`,
    //       name: "Qué es el ID IGP?"
    //     },
    //     {
    //       tag: "Edificios Instrumentados",
    //       path: `/norma-e.030/edificios-instrumentados`,
    //       name: "Qué es un geoportal?"
    //     }
    //   ]
    // },
    /*{
      path: "/glosario",
      tag: "Glosario",
      name: "Glosario"
    }*/
  ]
};
const trail = [
  {
    path: "https://www.gob.pe/igp",
    tag: "Portal IGP",
    name: "portal"
  },
  {
    path: "../",
    tag: "Servicios",
    name: "pi"
  },
  {
    path: "/",
    tag: process.env.VUE_APP_TITLE,
    name: "root"
  }
];
const dynamicTrail = [
  {
    tag: "Subprogramas",
    path: "/subprogramas"
  },
  {
    tag: "Proyectos",
    path: "/proyectos"
  }
];
function getMenu(program) {
  return menu[program] || "cts";
}
function getTrail() {
  return trail;
}
function getDynamicTrail() {
  return dynamicTrail;
}

function getSection(program, path) {
  let children = menu[program].find(group => {
    if (group.children)
      return group.children.find(child => {
        // console.log("Children", group.children);
        // console.log("Chil path", child.path);
        // console.log("Path Split",path.split("?")[0]);
        // console.log("Children.children", children);
        return child.path == path.split("?")[0];
      });
    /*  else{
                return group.path == view
            } */
  });
  return children ? children.children : null;
}

function getSubSection(program, path) {
  let subchildren = menu[program].find(group => {
    
    if (group.subchildren.subchildren)
      return group.subchildren.subchildren.find(child => {
        console.log("Sub subChildren", child.path);
        return child.path == path.split("?")[0];
        
      });
    /*  else{
                return group.path == view
            } */
  });
  return subchildren ? subchildren.subchildren : null;
}
export { getSection, getSubSection, getMenu, getTrail, getDynamicTrail };
